module.exports = __webpack_public_path__ + "img/x5.2582c2bd.jpg";